/* @flow */

import * as React from 'react';
import styled from 'styled-components';
import Router from 'next/router';
// $FlowFixMe
import { TwoFactor } from '@bijie/react-bnb-biz';

import TwoFALocale from '../../../config/twoFALocale';

const Content = styled.div`
  width: auto;
  cursor: pointer;
`;

type Props = {
  i18n: Object,
  locale: string,
  element: any
};

type State = {
  isShowModal: boolean,
}

export default
class KYCEntryWithout2FA extends React.PureComponent<Props, State> {
  static defaultProps = {
    i18n: {},
    locale: 'en',
    element: null,
  };

  state = {
    isShowModal: false,
  }

  _handleClick = (e: MouseEvent) => {
    e.stopPropagation();
    this.setState({
      isShowModal: false,
    });
  };


  render() {
    const { locale, i18n, element } = this.props;
    const { isShowModal } = this.state;
    return (
      <Content onClick={() => this.setState({ isShowModal: true })}>
        {element}
        <TwoFactor.Modal
          visible={isShowModal}
          autoFocus={true}
          google={false}
          mobile={false}
          enable={{
            locale: TwoFALocale(i18n).enable,
            onSkip: this._handleClick,
            onGoogleJump: () => Router.push(`/${locale}${TwoFALocale(i18n).enable.enableGooglePath}`),
            onSmsJump: () => Router.push(`/${locale}${TwoFALocale(i18n).enable.enableSmsPath}`),
          }}
          onOk={val => console.log(val)}
        />
      </Content>
    );
  }
}
